import React from "react";
import PropTypes from "prop-types";
import {Input as BambooInput} from '@stubhub/bamboo';
import "./index.scss";

export default function Input({
  disabled,
  className,
  id,
  inputRef,
  onBlur,
  max,
  maxLength,
  min,
  minLength,
  onChange,
  onFocus,
  onInvalid,
  pattern,
  placeholder,
  required,
  step,
  tabIndex,
  type,
  value,
  ...otherProps
}) {

  // type='number' doesn't work on ios safari without a pattern
  // https://stackoverflow.com/questions/14447668/input-type-number-is-not-showing-a-number-keypad-on-ios
  if(!pattern && type === "number") {
    pattern = "\\d*";
  }

  return (
    <BambooInput
      disabled={disabled}
      className={className}
      id={id}
      inputRef={inputRef}
      max={max}
      maxLength={maxLength}
      minLength={minLength}
      min={min}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      onInvalid={onInvalid}
      pattern={pattern}
      placeholder={placeholder}
      required={required}
      step={step}
      tabIndex={tabIndex}
      type={type}
      value={value}
      {...otherProps}
    />
  );
}

Input.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]),
  id: PropTypes.string,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({current: PropTypes.node})
  ]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  maxLength: PropTypes.number,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  minLength: PropTypes.number,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onInvalid: PropTypes.func,
  pattern: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  required: PropTypes.bool,
  step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tabIndex: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.string
};

Input.defaultProps = {
  type: "text",
  tabIndex: 0
};
